(() => {
  if (customElements.get('lumive-sticky-sale-banner')) return;

  class LumiveStickySaleBanner extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.announcement-bar-section');
      if (!this.section) return;

      this.updateHeight = () => {
        const height = this.section.getBoundingClientRect().height;
        if (height > 0 && height !== this.lastHeight) {
          document.documentElement.style.setProperty('--lumive-sale-height', `${height}px`);
          this.lastHeight = height;
        }
      };
      this.lastHeight = null;
      this.updateHeight();
      this.observer = new ResizeObserver(this.updateHeight);
      this.observer.observe(this.section);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (!document.querySelector('lumive-sticky-sale-banner')) {
        document.documentElement.style.removeProperty('--lumive-sale-height');
      }
    }
  }

  customElements.define('lumive-sticky-sale-banner', LumiveStickySaleBanner);
})();
